import React from "react";
import { Container, Divider, Grid, Segment } from "semantic-ui-react";
import IkonHjerte from "../../images/Gift-Heart.png";
import IkonRegn from "../../images/Rain-Umbrella.png";
import IkonSol from "../../images/Weather-Sun.png";
import HeaderImage from "../common/HeaderImage";
import Forsidebillede from "../../images/Inspiration_Senior.jpg";

const InspirationSenior = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <HeaderImage imageSrc={Forsidebillede} />
    <Divider hidden />
    <Container text>
      <Segment basic>
        <h2 className="trompet">
          PLANLÆG DIN FREMTID – INSPIRATION TIL REFLEKSIONER
        </h2>
        <h2 className="ui header" style={{ paddingTop: 0 }}>
          Er du klar til at gå på pension – økonomisk og praktisk?
        </h2>
      </Segment>
    </Container>

    <Container text>
      <Segment basic>
        <p className="manchet">
          Få inspiration til hvilke overvejelser og refleksioner, du kan gøre
          for at finde ud af, hvad der er vigtigt for dig i din pensionstid. Tag
          et kig på de to cases nedenfor – de kan måske sætte gang i dine egne
          tanker.
        </p>

        <p>
          Når du ved, hvad der er vigtigt for dig, kan din rådgiver hjælpe med
          at udarbejde en plan, der sikrer, at du bruger af dine opsparinger og
          din formue på den mest fornuftige måde i forhold til dine planer og
          ønsker.
        </p>

        <Divider hidden />
        <Segment basic style={{ backgroundColor: "#f6f0e7" }}>
          <h3>Inspiration til dine overvejelser </h3>
          <Divider />
          <h4>Case 1: Mette og Karsten - Parate til at lave en plan</h4>
          <br />
          <p>
            Mette og Karsten er begge i 60’erne og nærmer sig pensionen. Mette
            har allerede trukket sig tilbage fra sit arbejde som pædagog, mens
            Karsten har planer om at arbejde deltid frem til han fylder 70 år.
            De er sikre på, at de vil blive boende i deres nuværende hus – et
            hus med lavt energiforbrug og en dejlig have. Men de ønsker også at
            sikre sig, at de økonomisk har nok til både at leve trygt og
            invitere børn og børnebørn med på en årlig rejse – en tradition de
            begyndte for to år siden, og som de gerne vil videreføre.
          </p>
          <p>
            Mette og Karsten har gennem årene indbetalt til pension via deres
            arbejde, men de vidste, at de havde brug for at få et klart billede
            af, hvordan deres opsparing kunne omdannes til en tryg og langsigtet
            økonomi. Deres rådgiver hjalp dem med at planlægge rækkefølgen af
            udbetalingen af deres pensioner og frie opsparing samt benytte
            afdragsfrihed på deres boliglån. Løsningen betyder, at de har plads
            til de aktiviteter, de ønsker for livet på pension; bueskydning, som
            de har kastet sig over de seneste år og tid og udflugter med
            børnebørnene, men i særdeleshed at kunne fortsætte den hverdag, de
            altid har værdsat højt.
          </p>
          <Divider />
          <h4>Case 2: Thomas og Louise - Klar til at tage skridtet videre</h4>
          <br />
          <p>
            Thomas og Louise er i 60’erne og har længe arbejdet med at få styr
            på deres pension. Men da Louise modtog arv fra sin far, blev de klar
            til at få en mere konkret plan. De har altid haft fokus på at
            indbetale det nødvendige beløb til pension, men har ikke haft behov
            for rådgivning indtil nu. Efter at have haft et møde med deres
            rådgiver, har de valgt at omlægge deres ratepension til en livsvarig
            pension og fået et klart billede af, hvordan deres økonomi ser ud,
            når arbejdslivet skiftes ud med livet på pension.
          </p>
          <p>
            Thomas og Louise værdsætter den tryghed, som rådgivningen har givet
            dem. De har fået afklaret, at de faktisk har de penge, de behøver
            til både rejser, dagligdag og uforudsete hændelser. Det giver dem ro
            i sindet at vide, at de har en plan, der tager højde for deres
            overgang til livet på pension, hvordan de bedst bruger af deres
            opsparing, og hvor meget de kan bruge hvornår.
          </p>
        </Segment>
        <Divider />
        <h3>Hvad bør du overveje? </h3>
        <br />

        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonHjerte})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Hvordan ønsker du at leve som pensionist?</h4>
              <ul>
                <li>
                  Har du drømme og planer om rejser, hobbyer eller tid med
                  familien?
                </li>
                <li>
                  Hvordan ser din bolig ud? Bliver du i dit nuværende hjem,
                  eller overvejer du at flytte?
                </li>
                <li>
                  Ønsker du en glidende overgang til pension, hvor du over tid
                  nedsætter din arbejdstid?
                </li>
                <li>
                  Hvilke forbrugsposter i din økonomi kommer til at ændre sig?
                </li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonRegn})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Er du forberedt på det uforudsete? </h4>
              <ul>
                <li>Hvad sker der, hvis du eller din partner bliver syg?</li>
                <li>
                  Testamente og begunstigelse - har du taget stilling til, hvem
                  der skal bruge dine penge, hvis du ikke selv skal?
                </li>
                <li>
                  Fremtidsfuldmagt - hvem skal hjælpe dig, hvis du ikke selv er
                  i stand til at tage vare på din økonomi eller dine personlige
                  forhold?
                </li>
              </ul>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{
                  backgroundImage: `url(${IkonSol})`,
                }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <h4>Kom godt i gang med seniorlivet </h4>
              <ul>
                <li>
                  Sundhedsstyrelsen har lavet{" "}
                  <a
                    href="https://www.sst.dk/-/media/Viden/Aeldre/Forebyggelse-blandt-%C3%A6ldre/Ti-gode-r%C3%A5d-om-overgangen-til-seniorlivet/Overgangen-til-seniorlovet-lang-webtilgaengelig.ashx?la=da&hash=AAF63613CF98A8B646DC746BE34C9C8CC8384D9F"
                    target="_blank"
                    rel="noreferrer"
                  >
                    10 gode råd om overgangen fra arbejdsmarkedet til
                    seniorlivet
                  </a>
                  . De 10 råd tager dig igennem de forskellige ting, du kan være
                  opmærksom på, når du overvejer at forlade arbejdsmarkedet.
                </li>
              </ul>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
      <Segment basic style={{ backgroundColor: "#f6f0e7" }}>
        <h3>Dit pengeinstitut kan hjælpe</h3>
        <p>
          Pengeinstitutter i Letpension-samarbejdet har stor ekspertise i
          pensionsplanlægning. De kan derfor hjælpe dig med at få overblik,
          inden du går på pension – hvad enten du skal på delpension, tidlig
          pension, efterløn eller folkepension. Udover et overblik over din
          formue får du også en skræddersyet pensionsplan. Det handler om at
          sikre, at du bruger af dine opsparinger og din formue på den mest
          fornuftige måde i forhold til dine planer og ønsker.
        </p>
        <p>
          <a href="/senior">
            Læs mere om pensionsplanslægning og typer af pensionsopsparinger
          </a>
        </p>
      </Segment>
    </Container>
  </div>
);

export default InspirationSenior;
